import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { Networks, useWhitelabel } from 'main/framework'
import { MapsGeocodeResultFields } from 'main/gql/maps'

import { Hidden, Visible } from 'main/ui'
import { AssetName, FilterBar, filtersPalette, IFiltersPalette } from 'main/util/asset'
import { IFilters } from 'main/util/search'

import {
  AgeRangeFilter,
  AvailabilityFilter,
  BudgetFilter,
  DaysPerWeekFilter,
  DropOffHoursFilter,
  MobileFilter,
  NetworkRatingFilter,
  NetworkRatingFilterV2,
  PickUpHoursFilter,
  ProgramOfferingsFilter,
  ProgramTypeFilter,
  SpokenLanguageFilter,
  ToursAndEventsFilter,
} from './Filters'
import { Container } from './FiltersBar.styles'
import { FilterDisplayed } from './types'

interface IProps extends RouteComponentProps {
  mapLocation: MapsGeocodeResultFields | null
  filters: IFilters
  onChange: (filters: IFilters) => void
}

function FiltersBar(props: IProps) {
  const { filters, onChange } = props
  const [filterDisplayed, setFilterDisplayed] = React.useState<FilterDisplayed | null>(null)

  const whitelabel = useWhitelabel()
  const palette: IFiltersPalette = filtersPalette(whitelabel)
  const notUsingNewMexico = whitelabel.networkAbbr !== Networks.NM

  return (
    <>
      <Visible lg xl>
        <Container background={palette.bar[FilterBar.BACKGROUND]}>
          <AgeRangeFilter
            filters={filters}
            displayForm={filterDisplayed === FilterDisplayed.AgeRange}
            palette={palette}
            onChangeFilters={onChange}
            onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.AgeRange)}
            onRequestCloseForm={() => setFilterDisplayed(null)}
          />
          <AvailabilityFilter
            filters={filters}
            displayForm={filterDisplayed === FilterDisplayed.AvailabilityFilter}
            palette={palette}
            onChangeFilters={onChange}
            onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.AvailabilityFilter)}
            onRequestCloseForm={() => setFilterDisplayed(null)}
          />
          <DaysPerWeekFilter
            filters={filters}
            displayForm={filterDisplayed === FilterDisplayed.DaysPerWeek}
            palette={palette}
            onChangeFilters={onChange}
            onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.DaysPerWeek)}
            onRequestCloseForm={() => setFilterDisplayed(null)}
          />
          {notUsingNewMexico && (
            <>
              <DropOffHoursFilter
                filters={filters}
                displayForm={filterDisplayed === FilterDisplayed.DropOffHours}
                palette={palette}
                onChangeFilters={onChange}
                onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.DropOffHours)}
                onRequestCloseForm={() => setFilterDisplayed(null)}
              />
              <PickUpHoursFilter
                filters={filters}
                displayForm={filterDisplayed === FilterDisplayed.PickUpHours}
                palette={palette}
                onChangeFilters={onChange}
                onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.PickUpHours)}
                onRequestCloseForm={() => setFilterDisplayed(null)}
              />
            </>
          )}
          <ProgramTypeFilter
            filters={filters}
            displayForm={filterDisplayed === FilterDisplayed.ProgramType}
            palette={palette}
            onChangeFilters={onChange}
            onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.ProgramType)}
            onRequestCloseForm={() => setFilterDisplayed(null)}
          />
          <BudgetFilter
            filters={filters}
            displayForm={filterDisplayed === FilterDisplayed.Budget}
            palette={palette}
            onChangeFilters={onChange}
            onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.Budget)}
            onRequestCloseForm={() => setFilterDisplayed(null)}
          />
          <ToursAndEventsFilter
            filters={filters}
            displayForm={filterDisplayed === FilterDisplayed.ToursAndEvents}
            palette={palette}
            onChangeFilters={onChange}
            onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.ToursAndEvents)}
            onRequestCloseForm={() => setFilterDisplayed(null)}
          />
          {whitelabel.hideByDefaultExceptIfTrue(AssetName.NETWORK_RATING_FILTERS) && (
            <NetworkRatingFilter
              filters={filters}
              displayForm={filterDisplayed === FilterDisplayed.NetworkRating}
              palette={palette}
              onChangeFilters={onChange}
              onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.NetworkRating)}
              onRequestCloseForm={() => setFilterDisplayed(null)}
            />
          )}
          {whitelabel.hideByDefaultExceptIfTrue(AssetName.NETWORK_RATING_FILTERS_V2) && (
            <NetworkRatingFilterV2
              filters={filters}
              displayForm={filterDisplayed === FilterDisplayed.NetworkRatingV2}
              palette={palette}
              onChangeFilters={onChange}
              onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.NetworkRatingV2)}
              onRequestCloseForm={() => setFilterDisplayed(null)}
            />
          )}
          <SpokenLanguageFilter
            filters={filters}
            displayForm={filterDisplayed === FilterDisplayed.SpokenLanguages}
            palette={palette}
            onChangeFilters={onChange}
            onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.SpokenLanguages)}
            onRequestCloseForm={() => setFilterDisplayed(null)}
          />
          {whitelabel.hideByDefaultExceptIfTrue(AssetName.PROGRAM_OFFERINGS) && (
            <ProgramOfferingsFilter
              filters={filters}
              displayForm={filterDisplayed === FilterDisplayed.ProgramOfferings}
              palette={palette}
              onChangeFilters={onChange}
              onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.ProgramOfferings)}
              onRequestCloseForm={() => setFilterDisplayed(null)}
            />
          )}
        </Container>
      </Visible>
      <Hidden lg xl>
        <Container>
          <MobileFilter
            filters={filters}
            displayForm={filterDisplayed === FilterDisplayed.All}
            onChangeFilters={onChange}
            onRequestDisplayForm={() => setFilterDisplayed(FilterDisplayed.All)}
            onRequestCloseForm={() => setFilterDisplayed(null)}
          />
        </Container>
      </Hidden>
    </>
  )
}

export default withRouter(FiltersBar)
